


import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const ExportWorkProgressbyContractorN = (props) => {
    const { tableData, name, Tabledata, fromDate, toDate } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-ExportWorkProgressbyContractorN"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-ExportWorkProgressbyContractorN" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr >
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>
                <tr>
                    <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>From Date = {fromDate ? moment(fromDate).format('DD-MM-YYYY') : '-'}</th>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>To Date = {toDate ? moment(toDate).format('DD-MM-YYYY') : '-'}</th>
                </tr>

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        {Tabledata && Tabledata[0]?.Heading.map((i) => (

                            <th className="text-center fw-bold  py-2" style={{ whiteSpace: 'nowrap' }} key={i.head}>{i.head}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        tableData?.map((officer) => {
                            return (
                                <tr className="text-center" key={officer?.rowNum}
                                    style={{ textAlign: 'center', border: '1px solid black', verticalAlign: 'middle' }}
                                >
                                    <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                                    <td>{officer.wardName}</td>
                                    <td >{officer.totalAllCount}</td>
                                    <td >{officer.completedCount}</td>
                                    <td >{officer.pendingCount}</td>
                                    <td >{officer.pending_0_7DaysCount}</td>
                                    <td >{officer.pending_7_15DaysCount}</td>
                                    <td >{officer.pending_15_30DaysCount}</td>
                                    <td >{officer.pending_30_90DaysCount}</td>
                                    <td >{officer.pending_90_180DaysCount}</td>
                                    <td >{officer.pending_365DaysCount}</td>
                                </tr>

                            );
                        })}
                </tbody>
            </table>
        </div>
    )
}